import { TRANS_CATEGORY } from '@/constants';
import { ScreenSecurity } from '@/pages/Onboarding/Layouts/OwnAI/screens/Security';

import { ScreenEmail } from './screens/Email';
import { ScreenLookingFor } from './screens/LookingFor';
import { ScreenName } from './screens/Name';
import { ScreenPerfectLook } from './screens/PerfectLook';
import { ScreenPersonality } from './screens/Personality';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { SummaryScreen } from './screens/SummaryScreen';
import { ScreenTurnsOn } from './screens/TurnsOn';
import { WelcomeScreen } from './screens/Welcome';
import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  looking_for: {
    component: ScreenLookingFor,
    images: [],
  },
  turns_on: {
    component: ScreenTurnsOn,
    images: [],
  },
  perfect_look: {
    component: ScreenPerfectLook,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
  summary_screen: {
    component: SummaryScreen,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  name: '',
  email: '',
  looking_for: null,
  turns_on: null,
  perfect_look: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
};

//TRANS
export const HARDCODED_CATEGORIES = [TRANS_CATEGORY];
